/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createAbs } from '../../factoriesAny.js';
export var absDependencies = {
  typedDependencies,
  createAbs
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/lib/esm/entry/dependenciesAny/dependenciesAbs.generated.js
// module id = null
// module chunks = 